import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import ParameterModalUpdate from "./ParameterModalUpdate";
import ParameterIcon from "../../../components/card/widget/parameter/ParameterIcon";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import SrvButton from "../../../components/global/SrvButton";
import axios from "axios";
import ErrorAdd from "../../../util/ErrorAdd";

function ParameterModalAdd({ show, onHide }) {


    const [modalEditShow, setModalEditShow] = useState(false);

    const [name, setName] = useState(null);
    const [log, setLog] = useState(null);
    const [loading, setLoading] = useState(false);
    const [model, setModel] = useState(null);

    /*
    ID	Name
    1	Логический
    2	Число
    3	Строка
    4	Справочник
    5	Дата
    */

    const [typeParamSelected, setTypeParamSelected] = useState(null);
    const [typeParam, setTypeParam] = useState(
        [
            { id: 1, name: 'Логический', selected: false },
            { id: 2, name: 'Число', selected: false },
            { id: 3, name: 'Строка', selected: false },
            { id: 4, name: 'Справочник', selected: false },
            { id: 5, name: 'Дата', selected: false },
        ]
    );

    function update() {

        setLog(null);

        if (name == null || name == '' || name == undefined) {
            setLog('Введите название параметра');
        }
        else if (typeParamSelected === null) {
            setLog('Выберите тип параметра');
        }
        else {
            axios.post('/api_tracker/parameter/add', { ID_Type: typeParamSelected, Name: name, All_Object: true, All_Project: true })
                .then((res) => {
                    if (res.data.Status === 1) {
                        const id = res.data.Data;

                        axios.get('/api_tracker/parameter/get', { params: { ID_Parameter: id } })
                            .then((res1) => {
                                if (res1.data.Status === 1) {
                                    setModel(res1.data.Data);
                                    setModalEditShow(true);
                                    setLoading(false);
                                }
                                else {
                                    setLog(res1.data.Error);
                                    setLoading(false);
                                }
                            })
                            .catch((err) => {
                                setLog('Неизвестная ошибка!');
                                setLoading(false);
                                ErrorAdd(err, window.location.href);
                            });
                    }
                    else {
                        setLog(res.data.Error);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
    }

    return (
        <>
            {modalEditShow === true && (
                <ParameterModalUpdate show={modalEditShow} onHide={() => { setModalEditShow(false); onHide() }} model={model} />
            )}

            <Modal show={show} onHide={onHide} >
                <Modal.Body>
                    <div className="modal_close" onClick={onHide}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                    <div className="modal_title text-center">Добавление параметра</div>
                    <div className="mt-15">
                        <input type="text" className="form-control" disabled={loading} placeholder="Введите название..." onChange={(e) => setName(e.target.value)} />
                    </div>
                    <div className="mt-5 row">
                        {typeParam.map(item => (
                            <div key={item.id} className="col-4 mt-10" style={{ paddingLeft: '5px', paddingRight: '5px' }}>
                                <button className={'param_button' + (item.id === typeParamSelected ? ' active' : '')} onClick={() => setTypeParamSelected(item.id)}>
                                    <i className="mr-5"><FontAwesomeIcon icon={ParameterIcon(item.id)} /></i> <br></br>
                                    {item.name}
                                </button>
                            </div>
                        ))}
                    </div>
                    <div className="text_error text-center mt-10">{log}</div>
                    <div className="row">
                        <div className="col-md-12 text-center">
                            <SrvButton typeBtn="add" size='lg' loading={loading} onClick={() => update()} />
                        </div>
                    </div>
                </Modal.Body>
            </Modal >
        </>
    );
}

export default ParameterModalAdd;